export default "__VITE_ASSET__CiYyOQi8__"